import { SessionService, UserDirectoryService } from '@edl-development/edl-common';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { firstValueFrom } from 'rxjs';
import { resolveSearchCriteria } from 'src/app/administration/administration.states';
import { resolveItemPackets } from 'src/app/reports/reports/volunteer/volunteer-reports.states';
import { ItemPacketService } from 'src/app/services/item-packet/item-packet.service';
import { VolunteerReportHelperService } from 'src/app/services/volunteer/volunteer-report-helper.service';
import { VolunteerReportService } from 'src/app/services/volunteer/volunteer-report.service';
import { InCompliancePrintReportComponent } from './in-compliance-print-report/in-compliance-print-report.component';

export function getReportRequest(volunteerReportHelperService: VolunteerReportHelperService, transition: Transition) {
    const params = transition.params();
    const { searchBy, currentPage, itemPacket, orderBy, ascending, volunteerAreas, getAllResults } = params;
    return volunteerReportHelperService.getReportRequest({ searchBy, page: currentPage, limit: 1, itemPacket, orderBy, ascending, volunteerAreas, getAllResults: true });
}

export function resolveReportContent(volunteerReportHelperService: VolunteerReportHelperService, volunteerReportService: VolunteerReportService, transition: Transition) {
    const request = getReportRequest(volunteerReportHelperService, transition);
    return firstValueFrom(volunteerReportService
        .getInComplianceReport(request));
}


export let VolunteerPrintReportStates: Ng2StateDeclaration[] = [{
    name: 'print.reports.volunteer',
    url: '/reports/volunteer',
    abstract: true
}, {
    name: 'print.reports.volunteer.in-compliance',
    url: '/in-compliance?page?orderBy&ascending&itemPacket&volunteerAreas&searchBy',
    views: {
        'content@print': {
            component: InCompliancePrintReportComponent
        }
    },
    params: {
        currentPage: {
            type: 'int',
            value: 1,
        },
        itemPacket: {
            raw: true,
            value: '',
        },
        searchBy: {
            raw: true,
            value: '',
        },
        volunteerAreas: {
            raw: true,
            type: 'string',
            array: true,
            value: []
        },
        getAllResults: {
            raw: true,
            type: 'bool',
            value: false
        }
    },
    resolve: [
        {
            token: 'pagedResponse',
            deps: [VolunteerReportHelperService, VolunteerReportService, Transition],
            resolveFn: resolveReportContent,
        },
        {
            token: 'itemPackets',
            deps: [ItemPacketService, SessionService],
            resolveFn: resolveItemPackets
        }, {
            token: 'searchCriteria',
            deps: [SessionService, UserDirectoryService],
            resolveFn: resolveSearchCriteria
        }, {
            token: 'request',
            deps: [VolunteerReportHelperService, Transition],
            resolveFn: getReportRequest
        }]
}];